var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetingBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 352,
    viewBox: "0 0 352 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 176c0 97.201 78.8 176 176 176 97.201 0 176-78.799 176-176C352 78.8 273.204 0 176 0 78.8 0 0 78.8 0 176zm176 95.434c-7.721-20.272-19.735-39.283-36.07-55.616-19.262-19.265-42.247-32.53-66.636-39.818 24.39-7.288 47.374-20.553 66.636-39.818 16.335-16.333 28.346-35.347 36.07-55.616 7.721 20.272 19.735 39.283 36.067 55.616 19.262 19.262 42.246 32.53 66.636 39.818-24.39 7.284-47.374 20.553-66.636 39.818-16.332 16.333-28.346 35.347-36.067 55.616z",
    fill: "#fff"
  })));
}
export default SvgCompetingBottom;